// src/components/RouteModal/RouteModal.jsx
import React, { useState } from 'react';
import styles from './RouteModal.module.css';
import api from '../../../services/api';
export default function RouteModal({ onClose }) {
  const today = new Date().toISOString().split('T')[0];

  const [form, setForm] = useState({
    prefix: 'V',
    route_date: today,
    driver: '',
    loader1: '',
    loader1SameAsDriver: false,
    loader2: '',
    car: '',
    operator: '',
    delivery_volume: 0,
  });
  const [creating, setCreating] = useState(false);
  const [createError, setCreateError] = useState(null);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    if (name === 'loader1SameAsDriver') {
      setForm(f => ({
        ...f,
        loader1SameAsDriver: checked,
        loader1: checked ? f.driver : ''
      }));
    } else {
      setForm(f => ({
        ...f,
        [name]: value
      }));
    }
  };

  const handleCreate = async () => {
    setCreating(true);
    setCreateError(null);
    try {
      const payload = {
        ...form,
        loader1: form.loader1SameAsDriver ? form.driver : form.loader1,
        delivery_weight: form.delivery_volume * 19
      };
      // Здесь api возвращает сразу объект, без вложенного поля data
      const res = await api.post('/routes/init', payload);
      const created = res; // ответ — это уже новый маршрут

      onClose();

      // Навигация на страницу нового маршрута
      window.location.href = `RouteBuilder/${created.id}`;
    } catch (e) {
      setCreateError(
        e.response?.message ||
        e.message ||
        'Ошибка создания'
      );
    } finally {
      setCreating(false);
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <header className={styles.modalHeader}>
          <h3>Создать маршрутный лист</h3>
          <button onClick={onClose} disabled={creating}>✕</button>
        </header>
        <div className={styles.modalBody}>
          <label>
            Префикс:
            <input name="prefix" value={form.prefix} onChange={handleChange} />
          </label>
          <label>
            Дата маршрута:
            <input
              type="date"
              name="route_date"
              value={form.route_date}
              onChange={handleChange}
            />
          </label>
          <label>
            Водитель:
            <input name="driver" value={form.driver} onChange={handleChange} />
          </label>
          <label>
            Грузчик 1:
            <input
              name="loader1"
              value={form.loader1SameAsDriver ? form.driver : form.loader1}
              onChange={handleChange}
              disabled={form.loader1SameAsDriver}
            />
          </label>
          <label className={styles.checkboxLabel}>
            <input
              type="checkbox"
              name="loader1SameAsDriver"
              checked={form.loader1SameAsDriver}
              onChange={handleChange}
            />
            Грузчик 1 совпадает с водителем
          </label>
          <label>
            Грузчик 2:
            <input name="loader2" value={form.loader2} onChange={handleChange} />
          </label>
          <label>
            Машина:
            <input name="car" value={form.car} onChange={handleChange} />
          </label>
          <label>
            Оператор:
            <input name="operator" value={form.operator} onChange={handleChange} />
          </label>
          <label>
            Объём доставки (шт.):
            <input
              type="number"
              name="delivery_volume"
              min="0"
              step="1"
              value={form.delivery_volume}
              onChange={handleChange}
            />
          </label>
          <label>
            Вес доставки (кг):
            <input type="number" readOnly value={form.delivery_volume * 19} />
          </label>
          {createError && <div className={styles.error}>{createError}</div>}
        </div>
        <footer className={styles.modalFooter}>
          <button onClick={onClose} disabled={creating}>Отмена</button>
          <button onClick={handleCreate} disabled={creating}>
            {creating ? 'Создание...' : 'Создать'}
          </button>
        </footer>
      </div>
    </div>
  );
}
